declare global {
  interface Window {
    __DEVRAIN_TIME_CONFIG__?: {
      API_BASE_URL?: string;
      ENTRA_CLIENT_ID?: string;
      ENTRA_TENANT_ID?: string;
      ENTRA_AUTHORITY?: string;
      ENTRA_REDIRECT_URI?: string;
      APP_ENV?: string;
    };
  }
}

type RuntimeConfigKey = keyof NonNullable<Window['__DEVRAIN_TIME_CONFIG__']>;

const envKeyMap: Record<RuntimeConfigKey, string[]> = {
  API_BASE_URL: ['REACT_APP_API_URL', 'REACT_APP_API_BASE_URL'],
  ENTRA_CLIENT_ID: ['REACT_APP_ENTRA_CLIENT_ID', 'REACT_APP_AZURE_AD_CLIENT_ID'],
  ENTRA_TENANT_ID: ['REACT_APP_ENTRA_TENANT_ID', 'REACT_APP_AZURE_AD_TENANT_ID'],
  ENTRA_AUTHORITY: ['REACT_APP_ENTRA_AUTHORITY', 'REACT_APP_AZURE_AD_AUTHORITY'],
  ENTRA_REDIRECT_URI: ['REACT_APP_ENTRA_REDIRECT_URI', 'REACT_APP_AZURE_AD_REDIRECT_URI'],
  APP_ENV: ['REACT_APP_ENV', 'REACT_APP_ENVIRONMENT'],
};

const getEnvValue = (key: RuntimeConfigKey) => {
  for (const envKey of envKeyMap[key]) {
    const value = process.env[envKey]?.trim();
    if (value) {
      return value;
    }
  }

  return '';
};

const getConfigValue = (key: RuntimeConfigKey) => {
  return window.__DEVRAIN_TIME_CONFIG__?.[key]?.trim() || getEnvValue(key);
};

export const getApiBaseUrl = () => {
  const runtimeApiUrl = getConfigValue('API_BASE_URL');
  return runtimeApiUrl || '/api';
};

export const getEntraConfig = () => {
  const tenantId = getConfigValue('ENTRA_TENANT_ID');
  const clientId = getConfigValue('ENTRA_CLIENT_ID');
  const authority = getConfigValue('ENTRA_AUTHORITY') ||
    (tenantId ? `https://login.microsoftonline.com/${tenantId}` : '');

  return {
    tenantId,
    clientId,
    authority,
    redirectUri: getConfigValue('ENTRA_REDIRECT_URI') || window.location.origin,
  };
};

export const isEntraConfigured = () => {
  const config = getEntraConfig();
  return !!config.tenantId && !!config.clientId;
};

export const getAppEnvironment = () => getConfigValue('APP_ENV') || 'local';

export {};
